import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_p_mark.png'


const _withScopeId = n => (_pushScopeId("data-v-615a8276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_footer" }
const _hoisted_2 = { class: "entry_footer_contents" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"entry_footer_contents_pmark_block\" data-v-615a8276><a class=\"entry_footer_contents_link_pmark\" href=\"http://privacymark.jp/\" target=\"_blank\" data-v-615a8276><img class=\"entry_footer_contents_img_pmark\" src=\"" + _imports_0 + "\" alt=\"プライバシーマーク\" data-v-615a8276></a><div class=\"entry_footer_contents_number\" data-v-615a8276><div class=\"entry_footer_contents_number_text\" data-v-615a8276>厚生労働大臣許可番号</div><div class=\"entry_footer_contents_number_text\" data-v-615a8276>人材紹介 13-ユ-040475</div><div class=\"entry_footer_contents_number_text\" data-v-615a8276>人材派遣 派 13-040596</div></div></div><div class=\"entry_footer_contents_description\" data-v-615a8276>マスメディアンはプライバシーマークを取得しています。</div>", 2)
const _hoisted_5 = { class: "entry_footer_contents_copyright" }

import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = computed(() => {
  return new Date().getFullYear();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, "Copyright © 2001-" + _toDisplayString(_unref(currentYear)) + " MASSMEDIAN Co., Ltd. All Rights Reserved.", 1)
    ])
  ]))
}
}

})